export default {
  button: {
    addDistributors: 'Aggiungere distributore',
    addMore: 'Aggiungere altro',
    addMoreProduct: 'Aggiungere altro prodotto',
    addMoreProductForGiving: 'Aggiungere altro prodotto da regalare',
    addMoreProductForOrder: 'Aggiungere altri prodotti all\'ordine',
    addMoreTime: 'Aggiungere più tempo',
    addNewGroup: 'Aggiungere nuovo Gruppo',
    addProduct: 'Aggiungere prodotto',
    addSalesOrder: 'Aggiungere Ordine di Vendita',
    addStoreToGroup: 'Aggiungere negozio al Gruppo',
    addStores: 'Aggiungere negozi ',
    addToStoreGroup: 'Aggiungere al Gruppo di Negozi',
    agree: 'Accettare',
    alreadyInOperation: 'Già in funzione',
    assign: 'Assegnare',
    btnCode: 'Visualizzare il QR Code d\'invito al negozio',
    cancel: 'Annullare',
    clear: 'Cancellare',
    clearSelected: 'Cancellare la selezione',
    close: 'Chiudere',
    confirm: 'Confermare',
    continueEditing: 'Continuare la modifica',
    copyLink: 'Copiare link',
    create: 'Creare',
    createANewReOrder: 'Creare un nuovo ordine ',
    createNewDistributorMapping: 'Creare una nuova mappa del distributore',
    createNewStoreVisit: 'Creare una nuova visita al negozio',
    delete: 'Eliminare',
    detail: 'Dettaglio',
    distributorDetial: 'Dettagli del distributore',
    edit: 'Modificare',
    eventApplication: 'Domanda di partecipazione all\'evento',
    eventExecution: 'Esecuzione dell\'evento',
    exchange: 'Cambio',
    gotIt: 'Capito',
    ignore: 'Ignorare',
    invitationInfo: 'Informazioni sull\'invito',
    inviteStoresToParticipate: 'Invitare i negozi a partecipare',
    launch: 'Lancio',
    login: 'Login',
    manage: 'Gestire',
    navigate: 'Navigare',
    nextStep: 'Passo successivo',
    previous: 'Precedente',
    reject: 'Rifiutare',
    remove: 'Rimuovere',
    reset: 'Reset',
    review: 'Revisione',
    save: 'Salvare',
    search: 'Ricercare',
    select: 'Selezionare',
    selected: 'Selezionato',
    sellOut: 'Esaurito',
    stillCancel: 'Annullare ancora',
    storeDetial: 'Dettagli del negozio',
    storeInfo: 'Informazioni del negozio',
    storeTagDetermination: 'Determinazione dell\'etichetta del negozio',
    submit: 'Inviare',
    submitForReview: 'Inviare per la revisione',
    thinkAgain: 'Pensarci ancora',
    types: 'tipi',
    viewActivatedStores: 'Visualizzare i negozi attivi',
    viewRecentReOrder: 'Visualizzare gli ordini recenti',
    viewRecentVisitRecords: 'Visualizzare i dati delle visite recenti',
    viewStoreMotivationStatus: 'Visualizzare lo stato di coinvolgimento del negozio',
    visitInfo: 'Informazione della visita'
  },
  form: {
    achievementRate: 'Tasso di successo',
    actualTraffic: 'Flusso effettivo (periodo dell\'evento)',
    addToSchedule: 'Aggiungere al programma',
    address: 'Indirizzo',
    afterSalesQuantityPcs: 'Quantità post-vendita (unità)',
    afterSalesService: 'Servizio post-vendita',
    afterTheEvent: 'Dopo l\'evento',
    assignedBaBd: 'Assegnato a BA / BD',
    averageOfDisposableCustomerTraffic: 'Media del flusso di clienti di prodotti "usa e getta"',
    averageOfOpenSystemCustomerTraffic: 'Media del flusso di clienti di prodotti a "Sistema Aperto"',
    averageOfTraffic: 'Flusso medio',
    averagePassengerFlow: 'Flusso medio di Visitatori',
    averageSalesPcsDay: 'Vendite medie (unità/giorno)',
    bannerFloorStandProductModelNotes: 'Esposizione Banner / Supporto (Note)  ',
    basicInfo: 'Informazioni di base',
    beforeTheEvent: 'Prima dell\'evento',
    brandBannerDisplayed: 'Esposizione Banner del Brand',
    brandBannerProductModelNotes: 'Modello del prodotto del Banner (Note)',
    brandBuyers: 'Acquirenti del Brand',
    brandDay: 'Giornata del Marchio',
    brandSupplierDistributor: 'Fornitore del Brand (Distributore)',
    business: 'Business',
    businessStatus: 'Status del Business',
    businessType: 'Tipo di attività',
    chainOrNot: 'Catena o no',
    checkInPhoto: 'Foto check-in',
    chooseDate: 'Sceglere la data',
    cityNeighborhoodStreetOrBuilding: 'Città, quartiere, strada o edificio',
    competitorPrice: 'Prezzo della concorrenza',
    consumablesRatio: 'Rapporto materiali di consumo (rapporto pod/mod / resistenze/dispositivi)',
    contactPosition: 'Posizione del contatto',
    corePromotedProductBrand: 'Principale prodotto in promozione del marchio',
    country: 'Nazione',
    createANewStoreMapping: 'Crea una mappatura del nuovo negozio',
    currentProductListingStatus: 'Stato attuale del prodotto in elenco',
    customerReach: 'Raggiungimento del cliente ',
    dayOfPromotion: 'Giorno della Promozione',
    daysInAdvance: 'Giorni in anticipo',
    decisionMakerInfo: 'Informazioni su chi prende le decisioni',
    decisionMakerName: 'Nome del responsabile',
    decisionMakerRole: 'Ruolo del responsabile',
    directOrNot: 'Diretto o no',
    directSellIn: 'Vendita diretta (Sell-in)',
    displayMerchandising: 'Esposizione & Merchandising',
    displayPhoto: 'Mostrare la foto',
    disposable: 'Usa e Getta',
    disposableBrandDiversity: 'Diversità dei marchi di prodotti "Usa e Getta"',
    disposableCustomerTraffic: 'Flusso di clienti "Usa e Getta"',
    disposableSales: 'Vendite di prodotti usa e getta',
    distributorID: 'ID Distributore',
    distributorName: 'Nome del Distributore',
    distributorNamePostCodeAddressCityVisitBa: 'Nome del distributore / Codice postale / Indirizzo / Città / BA che visita',
    distributorTag: 'Etichetta del distributore',
    distributorType: 'Tipo di distributore',
    eXWEstimatedPrice: 'Prezzo EXW stimato ($)',
    editReason: 'Motivo della modifica',
    email: 'E-mail',
    endOfSales: 'Fine delle vendite',
    endTime: 'Fine del tempo',
    estimatedPriceOfConsumablesEXW: 'Prezzo EXW stimato dei materiali di consumo ($)',
    eventActualSales: 'Vendite effettive dell\'evento (unità)',
    eventFeedback: 'Feedback sull\'evento',
    eventPhotos: 'Foto dell\'evento',
    eventSellInStoreTarget: 'Obiettivo vendite del negozio per l\'evento',
    eventStoreContactName: 'Nome del referente del negozio per l\'evento',
    eventTime: 'Orario dell\'evento',
    eventType: 'Tipo di evento',
    expectedTime: 'Tempo previsto',
    facebookInstagramAvailable: 'Disponibile su Facebook/Instagram',
    firistOrder: 'Primo Ordine',
    firstTimeOrNot: 'Prima volta o no',
    footTrafficInformation: 'Informazioni sul flusso di persone',
    image: 'Immagine',
    inv: 'Inv',
    invalid: 'Non valido',
    inventory: 'Inventario',
    invitationsInfo: 'Informazioni sugli inviti',
    isItRecommendedForRoutineOperation: 'È consigliato per un uso di routine?',
    isThereAnInvitationForAnEvent: 'C\'è un invito per un evento?',
    kOSGroupInvitation: 'Invito del Gruppo KOS',
    kOSGroupJoinScreenshot: 'Screenshot dell\'adesione al gruppo KOS',
    keyDistributor: 'Distributore chiave',
    lastest: 'Ultime notizie',
    listed: 'Riferimento',
    listing: 'In fase di introduzione',
    listingOrNot: 'Introdotto o no',
    listingProductSupplierDistributor: 'Fornitore dei prodotti elencati (Distributore)',
    listingStatus: 'Stato dell\'elenco',
    lssueDeviceMode: 'Problema relativo alla modalità operativa del dispositivo',
    lssusDescription: 'Descrizione del problema',
    mDWholesalePrice: 'Prezzo in distribuzione dei MD ($)',
    marketFeedback: 'Feedback del mercato',
    marketInformationCollection: 'Raccolta delle informazioni di mercato',
    materialDelivery: 'Consegna del Materiale',
    materialSampleDelivery: 'Consegna di Materiali e Campioni',
    materialSamplePhoto: 'Foto dei Materiali e dei Campioni',
    month: 'Mese',
    monthlyAverageSalesForKit: 'Vendite medie mensili del kit (unità)',
    name: 'Nome',
    namePostCodeAddressCity: 'Nome / Codice postale / Indirizzo / Città',
    newBuyers: 'Nuovi acquirenti',
    newBuyersReOrderStoreCount: 'Nuovi acquirenti e numero di riordini',
    newGroup: 'Nuovo Gruppo',
    notKeyDistributor: 'Non è un distributore chiave',
    notListing: 'Non in elenco',
    notes: 'Note',
    numberOfAffiliatedCoreStore: 'Numero di negozi principali affiliati',
    numberofChainStores: 'Numero di negozi di catena',
    officialWebsiteAvailable: 'Sito web ufficiale disponibile',
    openSystem: 'Sistema Aperto',
    openSystemCustomerTraffic: 'Flusso di clienti per Sistemi Aperti',
    openSystemSales: 'Vendite di Sistemi Aperti',
    orderGiftVolume: 'Volume dell\'ordine in omaggio',
    orderModificationHistory: 'Cronologia della modifica dell\'ordine',
    orderSalesVolume: 'Volume degli ordini di vendita',
    orders: 'Ordini',
    other: 'Altro',
    otherCategory: 'Altre Categorie',
    otherCosts: 'Altri costi (materiali, ecc.)',
    otherDistributor: 'Altro distributore',
    outsidePicture: 'Immagine esterna',
    overallSalesPerformance: 'Risultati complessivi di vendita',
    pO: 'PO',
    pOOrder: 'Ordine PO',
    paid: 'Pagato',
    passengerFlowStatistics: 'Statistiche sul flusso di clienti (periodo dell\'evento)',
    password: 'Password',
    paymentStatus: 'Stato del pagamento',
    paymentType: 'Tipo di pagamento',
    pcs: 'Pezzi',
    percentageOfDisposable: 'Percentuale prodotti "Usa e Getta"',
    percentageOfOpenSystem: 'Percentuale Sistemi Aperti',
    permanentlyClosed: 'Chiuso definitivamente',
    phone: 'Telefono',
    phoneNumber: 'Numero di telefono',
    photo: 'Foto  ',
    planName: 'Nome del piano',
    plannedVisitDate: 'Data prevista per la visita',
    pleaseSelect: 'Selezionare per favore',
    poPhoto: 'Foto PO',
    policy: 'Policy',
    popUp: 'Pop Up',
    popupDisplayPics: 'Immagini Pop Up',
    position: 'Posizione',
    posterDisplayed: 'Poster esposto',
    preEventWarmUpCooperation: 'Cooperazione in preparazione dell\'evento',
    productCashCheque: 'Prodotto + Contanti / Assegno',
    productDailySales: 'Vendite giornaliere del prodotto',
    productInfo: 'Informazioni sul prodotto',
    productListingStatus: 'Stato dell\'introduzione del prodotto',
    productSalesInventory: 'Vendite e inventario dei prodotti',
    promotionCapability: 'Capacità promozionale',
    promotionCapabillty: 'Capacità promozionale',
    promotionEffect: 'Effetto della Promozione',
    quantityGivenAwayPcs: 'Quantità distribuita (pezzi)',
    quantitySoldPcs: 'Quantità vendute (pezzi)',
    receipt: 'Ricevuta',
    recommendationsEventInvitations: 'Raccomandazioni e inviti a eventi',
    recommendedForRoutineOperation: 'Consigliato per uso di routine',
    reorderBuyers: 'Acquirenti con ordini ripetuti',
    retailPrice: 'Prezzo al dettaglio',
    retailPriceMoney: 'Prezzo al dettaglio ($)',
    retailerPurchasePrice: 'Prezzo di acquisto negoziante',
    rollUpBannerOrFloorStandDisplay: 'Roll-Up o Espositore da pavimento',
    ruleTipsOne: 'Selezionare un negozio per favore',
    salesBeforePromotion: 'Vendite prima della promozione (pezzi/giorno)',
    salesPcs: 'Vendite (pezzi)',
    salesPcsWeek: 'Vendite (pezzi/settimana)',
    salesPerformance: 'Risultati delle vendite',
    salesPerformancePcs: 'Risultati delle vendita (pezzi)',
    salesReorderForecast: 'Previsioni di vendita e riordini',
    salesTargetForThisEventPcs: 'Obiettivo di vendita per questo evento (pezzi)',
    sample: 'Campione',
    sampleConsumed: 'Campione consumato',
    sampleDelivery: 'Consegna del campione',
    sampleGiveawayPcs: 'Campioni omaggio (pezzi)',
    samplePhoto: 'Foto del Campione',
    searchBrandOrProduct: 'Cercare il marchio o il prodotto...',
    selectEndTime: 'Selezionare l\'ora della fine',
    selectProductsToUpdateListingStatus: 'Selezionare i prodotti per aggiornare lo stato dell\'elenco',
    selectStartTime: 'Selezionare l\'ora di inizio',
    selectTimePeriod: 'Selezionare il periodo di tempo',
    sellInByMyselfThisTime: 'Vendita diretta da parte mia questa volta',
    sellInFromAcmefog: 'Vendita da ACMEFOG',
    sellInFromDistributor: 'Vendita da parte del distributore',
    sellInPhoto: 'Foto della Vendita',
    sellInQuantity: 'Quantità venduta (pezzi)',
    sellOutOrders: 'Ordini di vendita (sell-out)',
    sentOut: 'Inviato',
    servicePhoto: 'Foto di servizio',
    staffName: 'Nome del personale',
    startTime: 'Ora di inizio',
    storeCapacityVerification: 'Verifica della capacità del negozio',
    storeGroup: 'Gruppo di negozi',
    storeID: 'ID Negozio',
    storeName: 'Nome Negozio',
    storeNamePostCodeAddressCityVisitBa: 'Nome del negozio / Codice postale / Indirizzo / Città / BA in visita',
    storePurchasePrice: 'Prezzo di acquisto del negozio ($)',
    storeServiceRecords: 'Dati di Servizio del Negozio',
    storeTag: 'Etichetta del negozio',
    storeType: 'Tipo di negozio',
    supportsPreEventInStoreDisplay: 'Supportare la visibilità dell\'evento in negozio prima dell\'evento stesso',
    tax: 'Tassa',
    taxExclusive: 'Escluso il pagamento delle imposte',
    taxInclusive: 'Tasse incluse',
    temporarilyClosed: 'Temporaneamente chiuso',
    testingStationDisplayed: 'Esposizione dello stand per le prove ',
    testingStationProductModelNotes: 'Prodotto in esposizione (Note)',
    timePeriods: 'Periodi di tempo',
    total: 'Totale',
    totalDisposableSales: 'Vendite totali di prodotti "Usa e Getta"',
    totalOpenSystemSales: 'Vendite totali dei Sistemi Aperti (pezzi/settimana)',
    totalOpenSystemsSales: 'Vendite totali dei Sistemi Aperti (pezzi/settimana)',
    totalProductSales: 'Vendite totali del prodotto',
    totalSalesInStoreDuringEvent: 'Vendite totali in negozio durante l\'evento (pezzi)',
    totalSalesPcs: 'Vendite totali (pezzi)',
    totalSellIn: 'Vendite totali (Sell-in)',
    totalStoreTraffic: 'Flusso totale di persone nel negozio',
    totalUsed: 'Totale utilizzato',
    uSD: 'USD',
    unpaid: 'Non pagato',
    userName: 'Nome Utente',
    visitDate: 'Data della visita',
    visitInfo: 'Informazioni della visita',
    warmUp: 'Preparazione',
    warmUpType: 'Tipo di Preparazione',
    wayOfList: 'Metodo di riferimento',
    weekdayFootTraffic: 'Flusso di clienti nei giorni feriali',
    weekdayPeakTraffic: 'Picco di flusso nei giorni feriali',
    weekendFootTraffic: 'Flusso di clienti nel weekend',
    weekendPeakTraffic: 'Picco di flusso nel weekend',
    weeklySalesInventoryBrforeEventPcs: 'Vendite settimanali e inventario prima dell\'evento (pezzi)',
    whatsAppGroupAvailable: 'Gruppo WhatsApp disponibile',
    wholesalePurchasePrice: 'Prezzo di acquisto all\'ingrosso',
    wholesaleRetailerPurchasePrice: 'Prezzo di acquisto all\'ingrosso e al dettaglio (USD)'
  },
  shared: {
    activity: 'Attività',
    addDistributorsToThePlan: 'Aggiungere i distributori al piano',
    addNewStoreMapping: 'Aggiungere la nuova mappatura del negozio',
    addNewStoreVisit: 'Aggiungere una nuova visita al negozio',
    addNewVisitSchedulePlannedVisitDate: 'Aggiungere una nuova pianificazione della visita, data prevista per la visita:',
    addRetailStoresToThePlan: 'Aggiungere i negozi al dettaglio al piano',
    addToExistingPlan: 'Aggiungere al piano esistente',
    addToVisitPlan: 'Aggiungere al piano visite',
    agreeToApplicationForKickOutOfOperation: 'D\'accordo con la richiesta di uscire dall\'operazione',
    anEventToBeHeld: 'Evento da tenere',
    aplyToKickOutOfOperation: 'Uscire dall\'operazione',
    applicable: 'Appropiato ',
    applicant: 'Richiedente',
    applicationForKickOutOfOperation: 'Richiesta di uscita dall\'operazione',
    approvalTime: 'Tempo di approvazione',
    approved: 'Approvato',
    approver: 'Decisore',
    auditResult: 'Risultato del Audit',
    automaticallyAddCurrentItemAfterCreation: 'Aggiungere automaticamente l\'elemento corrente dopo la creazione',
    bA: 'BA',
    balance: 'Bilancio',
    bindProduct: 'Prodotto di riferimento ',
    brandDayApplication: 'Richiesta per la Giornata del Marchio',
    buy: 'Comprare',
    by: 'da',
    byDay: 'Al giorno',
    byTime: 'Per tempo',
    byVisitBy: 'Visita effettuata da',
    cancelAllocationOfStores: 'Annullare l\'assegnazione dei negozi',
    cancelBrandDay: 'Annullare la giornata del Brand',
    cancelPopUpEvent: 'Annullare l\'evento Pop Up',
    cancelVisitSchedule: 'Annullare la pianificazione della visita',
    changeDetails: 'Dettagli della modifica',
    closed: 'Chiuso',
    collecting: 'Raccolta',
    completed: 'Completato',
    confirmRedemaption: 'Confermare il rimborso',
    createNewVisitPlan: 'Crea un nuovo piano di visite',
    createVisitPlan: 'Creare un piano di visita',
    creditBreakdown: 'Ripartizione del credito',
    creditEarned: 'Credito maturato',
    creditTransactionHistory: 'Cronologia delle transazioni ',
    current: 'Attuale',
    daily: 'Quotidiano',
    dateOfInvitation: 'Data dell\'invito',
    day: 'Giorno',
    daysAgo: 'giorni fa',
    deadline: 'Scadenza',
    development: 'Sviluppo',
    distributor: 'Distributore',
    distributors: 'Distributori',
    distroInfo: 'Informazioni sulla Distribuzione',
    dynamics: 'Dinamica',
    earnedPoints: 'punti guadagnati {totalIntegral}',
    end: 'Fine',
    event: 'Evento',
    eventExecute: 'Esecuzione evento',
    eventInvitations: 'Inviti all\'evento',
    eventInvite: 'Invito all\'evento',
    eventPolicy: 'Politica dell\'evento',
    expectTime: 'Tempo d\'attesa',
    feedback: 'Feedback',
    filter: {
      accountManagement: 'Gestione account',
      activated: 'Attivato ',
      all: 'Tutto',
      allType: 'Tutti i tipi',
      average: 'Media',
      brand: 'Brand',
      brandFilter: 'Filtro della Marca',
      confirm: 'Confermare  ',
      containAll: 'Contenere (Tutto)',
      containAny: 'Contenere (Alcuni)',
      customize: 'Personalizzare',
      distanceEarliest: 'Mappatura del negozio: il più recente',
      distanceFarthest: 'Distanza: il più lontano',
      distanceLatest: 'Mappatura dei negozi: Ultime novità',
      distanceNearest: 'Distanza: il più vicino',
      effective: 'Efficace',
      endDate: 'Data della Fine',
      filter: 'Filtro  ',
      good: 'Buono',
      goodTop: 'Buono: Marchi di fascia alta e media',
      high: 'Alto',
      inMonth: 'In un mese',
      inTwoWeeks: 'In due settimane ',
      inWeek: 'In una settimana',
      incentiveHistory: 'Storia degli incentivi',
      kA: 'KA',
      lessThanDays: 'Meno di 7 giorni',
      low: 'Basso',
      mD: 'Distributore Principale',
      me: 'Me',
      needTo: 'Abbiamo bisogno di',
      no: 'No',
      noFilter: 'Senza Filtro',
      notActivated: 'Non Attivato',
      notContainAny: 'Non contenere (Alcuni)',
      notEqualTo: 'Diverso da (Tutti)',
      notNeedTo: 'Non abbiamo bisogno di',
      notParticipated: 'Non ha partecipato',
      notSet: 'Non configurato',
      operationBottonmost: 'Operazione: Bassa',
      operationTopmost: 'Operazione: Massima',
      participated: 'Partecipato',
      poor: 'Povero',
      poorMainly: 'Povero: Principalmente Marche Top',
      potential: 'Potenziale',
      procMgr: 'Responsabile di processo',
      product: 'Prodotto',
      reset: 'Reset',
      rich: 'Ricco',
      richTop: 'Ricco: marchi di fascia alta, media e bassa',
      russia: 'Russia',
      sDMultiItemDistro: 'SD (Distribuzione multi-articolo)',
      sDSmokeDistro: 'SD (Distribuzione articoli per fumatori)',
      sVIPCore: 'SVIP Core',
      salesclerk: 'Addetto alle vendite',
      selectDate: 'Selezionare la data',
      selectEndDate: 'Selezionare la data di finale',
      selectStartDate: 'Selezionare la data di inizio',
      shopkeeper: 'Negoziante',
      sort: 'Tipo',
      startDate: 'Data di inizio',
      time: 'Durata',
      timeDays: '7~15 giorni',
      timeFilter: 'Filtro per data',
      toBeVerified: 'Da verificare',
      type: 'Tipo',
      typeFilter: 'Filtro per tipo',
      unitedKingdom: 'Regno Unito',
      unitedStates: 'Stati Uniti',
      unknown: 'Sconosciuto',
      vIPCore: 'VIP Core',
      viewStore: 'Vedere il negozio',
      yes: 'Si'
    },
    from: 'da',
    get: 'Ottenere',
    giveUpReason: 'Ragioni della rinuncia',
    hideUpdate: 'Nascondi "aggiorna"',
    insufficientPoints: 'Punti insufficienti',
    inventoryPcs: 'Inventario (pezzi)',
    inviteFansToJoinTheCommunity: 'Invitare i fan a unirsi alla community',
    kickOut: 'Espellere',
    kickOutOfOperation: 'Espulsione dall\'operazione',
    kilometer: 'km',
    launchPopUpEvent: 'Evento di lancio',
    listingProduct: 'Elenco dei prodotti',
    loading: 'Caricamento…',
    locationName: 'Nome della posizione',
    mapping: 'Mappatura',
    markToIgnoreThisTransferAllocation: 'Contrassegnare per ignorare questo trasferimento e assegnazione',
    materialSample: 'Materiale/Campione',
    materialSampleDeliveryDataMaintenance: 'Gestione dei dati di consegna di materiali e campioni',
    metre: 'm',
    modifiedProductQuantity: 'Quantità de prodotto modificata',
    modifyBrandDayApplicationInfo: 'Modificare le informazioni del giorno del Brand',
    modifyPersonalInformation: 'Modificare le informazioni personali ',
    modifyReOrder: 'Modificare il Riordino',
    modifyStoreTag: 'Modificare l\'etichetta del negozio',
    more: 'Più',
    multiStopRoute: 'Itinerario con più fermate',
    myApproval: 'Mia approvazione',
    nearbyStores: 'Negozi nelle vicinanze',
    need: 'Bisogni',
    newDistributorMapping: 'Nuova mappatura del distributore',
    newDistributorVisit: 'Visita del nuovo distributore',
    newReOrder: 'Nuovo riordino',
    newVisitSellIn: 'Nuova visita e vendita',
    nonEditable: 'Non modificabile',
    none: 'Nessuno',
    notChangedYet: 'Non ancora modificato',
    notStarted: 'Non avviato',
    offSite: 'Fuori sede',
    onSite: 'Sul posto',
    operation: 'Operazione',
    overdueFollowUp: 'follow-up in ritardo',
    pendingReview: 'In attesa di revisione',
    plannedVisitDate: 'Data prevista della visita',
    point: 'Punto',
    pointsRank: 'Classifica a punti',
    preEvent: 'Pre-evento',
    productBindingRecords: 'Dati correlati al prodotto',
    productDetails: 'Dettagli del prodotto',
    proofOfDelivery: 'Prova di consegna',
    psi: 'PSI',
    quanntityGivenAway: 'Quantità regalata',
    quanntitySold: 'Quantità venduta',
    reason: 'Motivo',
    records: 'Dati',
    redeemIncentiveRewardsForEmployees: 'Riscattare i premi incentivanti per i dipendenti',
    redeemedCredit: 'Credito riscattato',
    rejectApplicationForKickingOutUpStore: 'Rifiutare la richiesta di espulsione del negozio',
    rejected: 'Respinto',
    relevantVisitPlans: 'Piani di visita pertinenti',
    removedDistributor: 'Distributore rimosso',
    removedProducts: 'Prodotti rimossi',
    reorder: 'Riordinare',
    reorderPcs: 'Riordinare (pezzi)',
    report: 'Report',
    reportPopUpEventExecutionStatus: 'Stato di esecuzione dell\'evento del report',
    reportingOnTheBrandDayExecution: 'Resoconto sull\'esecuzione del Giorno del Marchio',
    reviewStatus: 'Stato della revisione',
    rules: 'Regole',
    sN: 'Numero di serie',
    salesPcsWeek: 'Vendite (pezzi/settimana)',
    schedule: 'Programma',
    selectDistributor: 'Selezionare il Distributore ',
    selectFromExistingPlan: 'Seleziona uno dei 4 piani esistenti',
    selectGiftToRedeem: 'Selezionare un regalo da riscattare',
    selectStore: 'Selezionare negozio',
    selectType: 'Selezionare il tipo',
    sellOutDataMaintenance: 'Manutenzione dei dati di vendita',
    sellOutProduct: 'Prodotto esaurito',
    setAssignedBABDInTheManagementSystem: 'Impostare il BA / BD nel sistema di gestione',
    setStoreLabels: 'Impostare le etichette del negozio',
    setStoreTag: 'Impostare l\'etichetta del negozio',
    setTheResponsiblePerson: 'Individuare la persona responsabile',
    startingNow: 'A partire da adesso',
    store: 'Negozio',
    storeActivity: 'Attività del negozio',
    storeAllocationTime: 'Tempo di allocazione del negozio',
    storeID: 'ID Negozio',
    storeIncentive: 'Incentivo al negozio',
    storeIncentiveBindProduct: 'Incentivo al negozio: collegare il prodotto',
    storeIncentiveDeactivateEmployeeAccount: 'Incentivo al negozio: Disattivare l\'account del Dipendente',
    storeIncentiveInviteEmployeeToActivate: 'Incentivo al negozio: Invitare il dipendente all\'attivazione',
    storeIncentiveUploadSalesProof: 'Incentivo al negozio: Caricare la prova della vendita',
    storeOperation: 'Operazione del negozio',
    storeParticipant: 'Partecipante nel negozio',
    storeTagChange: 'Modificare l\'etichetta del negozio',
    storeToDoItems: 'Elementi "TO DO" del negozio',
    stores: 'Negozi',
    storesAreTransferredAndAllocatedTo: 'I negozi vengono trasferiti e assegnati a',
    storesLevel: 'Livello dei negozi',
    submissionTime: 'Ora di invio',
    success: 'successo',
    summary: 'Riepilogo',
    theFirstSaleOrInvitation: 'La prima vendita o invito',
    timeOfApplication: 'Data della domanda',
    title: {
      activatedStores: 'Negozi Attivati',
      anEventStoreToBeHeld: 'Un evento del negozio da organizzare',
      basicInfo: 'Informazioni di base',
      createANewGroup: 'Creare un nuovo gruppo',
      createdSuccessfully: 'Creato con successo',
      days: 'Giorni',
      distributorInfo: 'Informazioni sul distributore',
      distributorMapping: 'Mappatura del distributore',
      distributorOperation: 'Operazione del distributore',
      editGroupName: 'Modificare il nome del gruppo',
      estimationOfResults: 'Stima dei risultati',
      eventHeld: 'Si è tenuto un evento?',
      eventRecord: 'Dato dell\'evento',
      filterDepartment: 'Filtrare per reparto',
      filterPerson: 'Filtrare per persona',
      illDesc: 'Descrizione dell\'immagine',
      incentive: 'Incentivo',
      listState: 'Stato della lista',
      manageMyGroups: 'Gestire i miei gruppi',
      mappingSucceed: 'Mappatura riuscita',
      marketInsight: 'Analisi di mercato',
      mySchedule: 'Il mio programma',
      orderDetail: 'Dettagli dell\'ordine',
      orderUpdateRecord: 'Cronologia delle revisioni dell\'ordine',
      others: 'Altri',
      overdueStoreFailureToFollowUp: 'Ritardo del follow-up da parte del negozio',
      oversightMatters: 'Questioni da controllare',
      participationRecord: 'Registro delle partecipazioni',
      pleaseSelectYourWorkItems: 'Selezionare i tuoi strumenti di lavoro',
      pointsRedemption: 'Riscatto punti',
      preparations: 'Preparativi',
      productListed: 'Elenco dei prodotti',
      prompt: 'Prompt',
      quickEntrance: 'Ingresso rapido',
      reOrderOrNot: 'Riassortimento o no',
      reOrderSellIn: 'Riordine (Sell-in)',
      retailOperationSystem: 'Sistema operativo per la vendita al dettaglio',
      ros: 'ROS',
      selectAPolicy: 'Selezionare una politica',
      selectGroup: 'Selezionare il gruppo',
      selectItemOfWork: 'Selezionare l\'elemento di lavoro',
      selectPlan: 'Selezionare il piano',
      selectRegion: 'Selezionare la regione',
      selectYearAndMonth: 'Selezionare l\'anno e il mese',
      state: 'Stato',
      storeAssignment: 'Assegnazione del punto vendita',
      storeDevelopment: 'Sviluppo del negozio',
      storeInfo: 'Informazioni sul negozio',
      storeMapping: 'Mappatura del negozio',
      storeTag: 'Etichetta del negozio',
      storeVisit: 'Visita del negozio',
      storesToBeAllocated: 'Negozi da assegnare',
      theNumberOfProductsSold: 'Il numero di prodotti venduti',
      timeSinceLastVisit: 'Tempo trascorso dall\'ultima visita',
      transferAllocationRecords: 'Registri di trasferimento e assegnazione',
      transferAndAllocate: 'Trasferire e assegnare',
      visitByBa: 'Visita del BA',
      visitOrNot: 'Visitare o no',
      whichDay: 'Quale giorno',
      minDays: 'Giorni min.',
      maxDays: 'Giorni max.'
    },
    titleEight: 'Nessun evento può durare più di {giorni} giorni',
    titleEighteen: 'Confermare la revoca di questo partecipante?',
    titleEleven: 'Fase 1 Informazioni di base sull\'evento corrente',
    titleFifteen: 'Fase 3 Elenco prodotti attuali e dati di vendita',
    titleFive: 'Recentemente il riordino del negozio é stato aggiornato. Vuoi aggiungere ancora qualcosa?',
    titleFour: 'Hai aggiornato di recente le informazioni relative alla visita di questo negozio. Vuoi continuare a modificare?',
    titleFourteen: 'Verificare la presenza di eventuali aggiornamenti. Le informazioni più recenti verranno automaticamente aggiornate nei dati di base dopo l\'invio della domanda di partecipazione all\'evento.',
    titleNine: 'L\'informazione dell\'evento deve essere inviato entro la tempistica stabilita. Un evento deve essere inserito una sola volta.',
    titleNineteen: 'Inviare il contenuto della notifica indicata in precedenza alla persona tramite SMS',
    titleOne: 'Filtrare i dati in base alla seguente condizione',
    titleSeven: 'Il seguente riepilogo delle attività viene generato automaticamente in base ai dati inseriti',
    titleSeventeen: 'Invitare i fan a unirsi alla community ed ottenere {totalIntegral} punti',
    titleSix: 'La visita per questo negozio è stata aggiornata di recente. Vuoi comunque creare una nuova visita?',
    titleSixteen: 'Fase 4 Stato di preparazione dell\'evento in corso',
    titleTen: 'Lo stato dell\'evento deve essere inviato quotidianamente. Un riepilogo dell\'evento verrà generato automaticamente al termine.',
    titleThirteen: 'Le seguenti informazioni verranno visualizzate automaticamente se sono già state inserite in precedenza.',
    titleThirty: 'Una volta che il trasferimento è andato a buon fine e non è più recuperabile, assicurati che il negozio abbia già messo il prodotto sugli scaffali.',
    titleThirtyOne: 'Il piano di visita è stato creato con successo ed è possibile aggiungere i negozi/distributori al percorso di visita pianificato.',
    titleThirtyThree: 'È necessario aggiornare lo stato delle schede prodotto questa volta?',
    titleThirtyTwo: 'Aggiungi {keyVal} ad altri piani di visita',
    titleThree: 'Hai recentemente aggiornato il riordino del negozio. Intendi continuare a modificarlo?',
    titleTwelve: 'Fase 2 {tipo} Informazioni di base',
    titleTwenty: 'Invitare il personale a informarsi sui requisiti per ricevere i bonus.',
    titleTwentyEight: 'Il livello del negozio non è stato determinato da quando ha cessato l\'attività. Da inviare.',
    titleTwentyFour: 'Descrivi il motivo per cui é stato escluso',
    titleTwentyNine: 'Trasferire il negozio a un "team operativo" e assegnare un supervisore.',
    titleTwentyOne: 'Riscatto riuscito. {currentIntegral} crediti sono stati detratti dall\'account di questo dipendente.',
    titleTwentySeven: '{backlogUserName} L\'evento {sourceName} inizierà alle {backlogTime}, Vai a vedere.',
    titleTwentySix: 'Ci sono inviti all\'evento del negozio che devono essere inviati. Vedere l\'invito.',
    titleTwentyThree: 'Domanda di esclusione dall\'Operazione',
    titleTwentyTwo: 'Sei sicuro di voler rimuovere questo prodotto?',
    titleTwo: 'Ultima visita di questa persona',
    titleThirtyFour: 'Inserisci il numero minimo di giorni, il numero massimo di giorni o entrambi. Lascia vuoto un campo se non si applica il limite corrispondente.',
    to: 'a',
    toBeAllocated: 'Da assegnare',
    today: 'oggi',
    transferAllocation: 'Trasferimento e assegnazione',
    transferAndAssignStoresTo: 'Trasferire e assegnare negozi a',
    underReview: 'In fase di revisione',
    updateDistributorMapping: 'Aggiorna la mappatura dei distributori',
    updateDistributorVisit: 'Aggiornamento sulla visita al distributore',
    updatePopUpEvent: 'Aggiornamento dell\'evento',
    updateRecord: 'Aggiornare il dato',
    updateStoreInfoBy: 'Aggiornamento delle informazioni da parte di',
    updateStoreMappingInformation: 'Aggiornare le informazioni sulla mappatura del negozio',
    updateStoreVisitInformation: 'Aggiornare le informazioni sulla visita al negozio',
    updateVisitSellIn: 'Aggiornare la visita e la vendita',
    uploadSalesReceipt: 'Carica la fattura della vendita',
    visit: 'Visita',
    visitPlan: 'Piano di visita',
    visitSellIn: 'Visita e vendita (Sell-in)',
    visitTime: 'Orario di visita',
    webSite: 'Sito web',
    yesterday: 'ieri'
  },
  tips: {
    accountOrPasswordIncorrect: 'Nome utente o password errati',
    addressCopiedFailed: 'Copia dell\'indirizzo non riuscita',
    addressCopiedSuccessfully: 'Indirizzo copiato correttamente',
    areYouSureToExit: 'Sei sicuro di voler uscire?',
    browserDoesNotSupportCopyFunction: 'Il browser non supporta la funzione di copia',
    checkInPhotoIsRequired: 'È richiesta una foto per il check-in.',
    chooseOnePersonAtLeast: 'Scegli almeno una persona',
    distributorPrice: 'Prezzo del distributore',
    eventCancelled: 'Evento annullato',
    filterByGroupName: 'Filtrare per il nome del gruppo',
    isRequired: 'è obbligatorio',
    locationNotFound: 'Posizione non trovata',
    loginSuccess: 'Accesso riuscito',
    messageEight: 'Se queste informazioni sono già state inviate in precedenza, i dati storici verranno compilati automaticamente. Si prega di modificarle direttamente se ci sono altri cambiamenti.',
    messageEleven: 'Incluso tutti I Sistemi Aperti / Usa e getta di altri Brand',
    messageFifteen: 'Confermare l\'eliminazione di questo ordine di vendita?',
    messageFifty: 'Questo piano di visita deve essere eliminato? Se è già stato creato un programma, verrà annullato automaticamente',
    messageFiftyOne: 'Desideri rimuovere l\'attuale {targetType} dal piano di visita e annullare la programmazione associata?',
    messageFiftyThree: 'Desideri eliminare questo piano di visita? Se è già stato creato un programma, verrà annullato automaticamente.',
    messageFiftyTwo: 'Creare automaticamente i programmi di visita per i negozi/distributori aggiunti a questo piano',
    messageFive: 'L\'ora di fine deve essere successiva all\'ora di inizio',
    messageForty: 'La mappatura attuale dei negozi ha successo e ulteriori informazioni sui negozi possono essere raccolte con le visite',
    messageFortyEight: 'Eliminare questo gruppo (questa azione elimina solo il gruppo, non i negozi al suo interno)',
    messageFortyFive: 'L\'Etichetta del negozio attuale è: {customerTag}. Desideri modificarlo?',
    messageFortyFour: 'Dopo la rimozione, il negozio non apparirà nell\'elenco finché il BA non lo invierà nuovamente.',
    messageFortyNine: 'Confermare il trasferimento del negozio e assegnarlo alla persona responsabile designata?',
    messageFortyOne: 'Modificare lo stato del negozio in: {statusVal}, il negozio non verrà mappato e visitato, confermi o no?',
    messageFortySeven: 'Se superi la revisione, l\'autorizzazione del negozio verrà rilasciata e trasferita all\'area "Espansione". I precedenti registri delle operazioni verranno archiviati automaticamente e non potranno essere modificati, quindi fai attenzione durante l\'operazione.',
    messageFortySix: 'Verrà trasferito al team "Sviluppo" con revoca delle autorizzazioni. I dati storici relativi alle operazioni verranno archiviati e non saranno modificabili.',
    messageFortyThree: 'Nessuna vendita o lista di vendita, non è consigliabile',
    messageFortyTwo: 'La vendita da parte mia questa volta è necessaria',
    messageFour: 'Tenere premuto (a lungo) per salvare nella galleria/album fotografico',
    messageFourteen: 'Eliminare i materiali selezionati e le relative quantità?',
    messageNine: 'Rimuovendo il prodotto, la quantità inserita verrà cancellata. Vuoi rimuoverlo?',
    messageNineteen: 'Attività da svolgere: quando un nuovo negozio viene assegnato a un dipendente, se il negozio ha un invito a un evento registrato, i dipendenti devono completare la presentazione dell\'evento e caricare l\'implementazione entro il tempo specificato.',
    messageOne: 'È possibile creare autonomamente gruppi di negozi per categorizzarli. I gruppi di negozi sono visibili solo a chi li ha creati.',
    messageSeven: 'L\'orario è errato',
    messageSeventeen: 'In attesa di revisione: le domande devono essere esaminate.',
    messageSix: 'Si prega di compilare tutte le informazioni richieste.',
    messageSixteen: 'Deve essere assegnato: inviare la visita a un negozio al Gruppo di Sviluppo dei negozi. Se almeno un prodotto è presente sugli scaffali nel record della visita, il sistema genererà automaticamente un record "negozio da assegnare" e il responsabile retail potrà trasferire e assegnare il negozio alla persona designata, che si occuperà del follow-up e della gestione.',
    messageTen: 'Inserire i dati di vendita pre-evento solo nel giorno 1',
    messageThirteen: 'Una volta annullato l\'evento, non sarà più possibile compilare il rapporto sull\'evento. Confermare l\'annullamento?',
    messageThirty: 'Rifiutare la richiesta di {createUserName} di escludere il negozio, confermare o no',
    messageThirtyEight: 'In base al funzionamento quotidiano del negozio, impostare l\'etichetta del negozio su',
    messageThirtyFive: 'Inserire le parole chiave per cercare i negozi',
    messageThirtyFour: 'Inserire il distributore di {projectName}',
    messageThirtyNine: 'Secondo l\'evento, l\'etichetta del negozio è impostata a',
    messageThirtyOne: 'La data di fine non può essere anteriore alla data di inizio.',
    messageThirtySeven: 'Eliminare i campioni selezionati e le quantità inserite?',
    messageThirtySix: 'Inserire le parole chiave per cercare il distributore',
    messageThirtyThree: 'Selezionare la data della visita',
    messageThirtyTwo: 'La mappatura dei distributori attualmente in uso ha successo e ulteriori informazioni possono essere raccolte grazie alle visite',
    messageThree: 'Invitare il personale ad aprire il concorso per l\'assegnazione dei premi.',
    messageTwelve: 'La richiesta di partecipazione all\'evento è stata inviata correttamente e l\'evento è stato automaticamente aggiunto al tuo programma giornaliero.',
    messageTwentyEight: 'Si prega di completare le informazioni',
    messageTwentyFive: 'Selezionare una posizione',
    messageTwentyFour: 'Inserire il tuo nome',
    messageTwentyNine: 'Se la richiesta è stata approvata, l\'autorizzazione del negozio verrà rilasciata e trasferita all\'area "Sviluppo". I precedenti record delle operazioni verranno archiviati automaticamente e non potranno essere modificati, quindi si prega di prestare attenzione all\'operazione.',
    messageTwentyOne: 'Tieni premuto a lungo il codice QR per salvarlo nell\'album',
    messageTwentySeven: 'Attivare l\'autorizzazione all\'evento e inviare un SMS di notifica al telefono cellulare della persona.',
    messageTwentySix: 'Inserire il tuo numero di cellulare completo',
    messageTwentyThree: 'Per garantire la corretta visualizzazione del link, si prega di verificare che il numero di telefono inserito sia corretto.',
    messageTwentyTwo: 'Impossibile ottenere l\'immagine del codice QR',
    messageTwo: 'Rimuovere il negozio dal gruppo (il negozio non verrà eliminato)',
    messgaeEighteen: 'Follow-up in ritardo: in base agli indicatori operativi aziendali, ai negozi principali/da testare viene impostata una frequenza di follow-up corrispondente e, se il follow-up supera l\'intervallo preimpostato, verrà attivato un avviso tempestivo.',
    messgaeTwenty: 'Partecipa all\'iniziativa scansionando il codice QR o cliccando sul link',
    networkError: 'Errore di rete',
    noAvailablePolicies: 'Nessuna politica disponibile',
    noData: 'Nessun dato',
    noMore: 'Non più',
    noMoreData: 'Nessun dato aggiuntivo',
    noMoreProducts: 'Niente più prodotti',
    noMoreStores: 'Niente più negozi',
    noMoreThan: 'Non più di 5',
    noPermissionYet: 'Nessuna autorizzazione ancora',
    nothingMore: 'Non c\'è altro da aggiungere!',
    noticeCopiedFailed: 'Fallimento nella copia dei dati',
    noticeCopiedSuccessfully: 'Avviso copiato correttamente',
    passwordIsRequired: 'È richiesta la password',
    pending: 'In attesa di',
    planningTheRoute: 'Pianificazione del percorso',
    pleaseChooseWhichDayToSell: 'Si prega di scegliere il giorno in cui effettuare la vendita',
    pleaseEnterAnInteger: 'Inserire un numero intero',
    pleaseEnterGroupName: 'Inserire il nome del gruppo',
    pleaseFillInTheSales: 'Si prega di compilare i dati di vendita',
    pleaseInputTheSales: 'Inserire i dati di vendita  ',
    pleaseSelectAGroup: 'Selezionare un gruppo',
    pleaseSelectProduct: 'Selezionare un prodotto',
    pleaseSelectThePlan: 'Selezionare il piano',
    productIsRequired: 'Il prodotto è necessario',
    reasonIsRequired: 'È necessario specificare il motivo',
    required: 'Necessario',
    sellInFromAcmefogInIsRequired: 'È richiesta la vendita da parte di Acmefog',
    stayTuned: 'Resta sintonizzato',
    storeTagIsRequired: 'L\'etichetta del negozio è necessaria',
    successSave: 'salvataggio riuscito',
    uploadFailed: 'Caricamento non riuscito',
    usernameIsRequired: 'è richiesto il nome utente'
  }
}
